import type { PropsWithChildren } from "react";
import { MnemonicGateReferenceSurfaceContext } from "#mnemonic-gate-reference-surface-context";

/**
 * Marks its subtree as the Reference page, which is the only surface allowed to gate a free
 * mnemonic behind a reveal button.
 *
 * Reference is a web-only, direct-link (SEO) page, so the reveal step and its account pitch reach
 * exactly the audience it was written for: a search visitor with no account. Regular app use —
 * the Info and Mnemonics panels on web and native alike — must never see that button.
 */
export function MnemonicGateReferenceSurfaceProvider({ children }: PropsWithChildren) {
  return (
    <MnemonicGateReferenceSurfaceContext.Provider value>
      {children}
    </MnemonicGateReferenceSurfaceContext.Provider>
  );
}
